


























import { Component, Mixins, Prop } from 'vue-property-decorator';
import BaseMixin from '@/mixins/base';
import { Location as RouteLocation } from 'vue-router/types/router';

@Component({
  mixins: [BaseMixin],
})
export default class SearchbarResultList extends Mixins(BaseMixin) {
  @Prop({ required: true, type: Array })
  private readonly items!: { title: string; items: { title: string; route: RouteLocation }[] }[];

  private get hasItems(): boolean {
    return this.items.some(item => item.items?.length) || false;
  }

  private itemClickHandler(location: RouteLocation): void {
    this.$emit('navigate', location);
  }
}
